import React from "react";
import Header from "../Components/nav";
import Footer from "../Components/footer";
import Cancellation from "../Components/cancellation";
import Bottomfooter from "../Components/bottomfooter";

const CancellationRoute = () => {
  return (
    <div>
      <Header />
      <Cancellation />
      <Footer />
      {/* <Bottomfooter /> */}
    </div>
  );
};

export default CancellationRoute;
